export default __webpack_public_path__ + "static/media/magento.dd040641.png";